import { getTeamTool } from './get_team.js';
import { listTeamsTool } from './list_teams.js';

export const teamTools = [listTeamsTool, getTeamTool];
